import { myTextLightGrey } from "./MyColors";

const highlightStyle = {
  display: "inline",
  fontFamily: "Calibre-Medium",
  color: myTextLightGrey,
};

export { highlightStyle };
